module.exports = new __parcel__URL__("shop_special_items_button_inactive.ad2dc279.png").toString();